import React from "react"
import {CombinedAssignmentItem} from "../AssignmentNavigator/AssignmentNavigator"
import {AssignmentNavigatorGroupSection} from "./AssignmentNavigatorGroupSection"

export type GroupedAssignments = {
	title: string
	assignment: CombinedAssignmentItem[]
}

interface AssignmentNavigatorGroupedByItemStageProps {
	groupedAssignments: GroupedAssignments[]
	navigatorItemRef: React.RefObject<HTMLLIElement>
}

export function AssignmentNavigatorWithGrouping({
	groupedAssignments,
	navigatorItemRef,
}: AssignmentNavigatorGroupedByItemStageProps) {
	return (
		<>
			{groupedAssignments.map(({title, assignment}) => (
				<AssignmentNavigatorGroupSection
					key={title}
					title={title}
					assignment={assignment}
					navigatorItemRef={navigatorItemRef}
				/>
			))}
		</>
	)
}
